import { render, staticRenderFns } from "./EditTracciaVuetify.vue?vue&type=template&id=1993c67c&scoped=true"
import script from "./EditTracciaVuetify.vue?vue&type=script&lang=js"
export * from "./EditTracciaVuetify.vue?vue&type=script&lang=js"
import style0 from "./EditTracciaVuetify.vue?vue&type=style&index=0&id=1993c67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993c67c",
  null
  
)

export default component.exports